<div class="flex flex-col gap-7 ep-running-logo px-4 pt-[10px]">
   @if (isLoadingLogo) {
      <app-basic-loader></app-basic-loader>
   } @else {
      <div class="flex gap-[100px]">
         <div class="flex flex-col gap-10">
            <div class="flex flex-col gap-3">
               <div class="flex flex-col gap-1">
                  <span class="text-sm">Logo preview</span>
                  <div class="flex gap-4">
                     <div
                        class=" {{
                           !croppedImageFile?.content && !croppedImageFile?.safeUrl ? 'bg-project-logo-placeholder' : ''
                        }} w-[122px] h-[94px] bg-cover bg-no-repeat bg-center border border-app-gray-3"
                     >
                        @if (croppedImageFile?.content || croppedImageFile?.safeUrl) {
                           <img
                              class="w-full h-full object-fill"
                              [src]="croppedImageFile?.content || croppedImageFile?.safeUrl"
                           />
                        }
                     </div>
                     @if (!showCropper && logo) {
                        <div class="flex flex-col gap-3">
                           <p-button
                              class="border border-app-primary-2 p-1 rounded h-fit btn-no-label"
                              styleClass="bg-white border-0 p-0 hover:!bg-white"
                              tooltipStyleClass="basic-app-tooltip-primary-2"
                              [showDelay]="500"
                              tooltipPosition="top"
                              pTooltip="{{ 'view' | translate }}"
                              (click)="showEnlargedLogo = true"
                           >
                              <i class="pi pi-eye logo-default-action"></i>
                           </p-button>
                           <p-button
                              class="border border-app-primary-2 p-1 rounded h-fit btn-no-label"
                              styleClass="bg-white border-0 p-0 hover:!bg-white"
                              tooltipStyleClass="basic-app-tooltip-primary-2"
                              [showDelay]="500"
                              tooltipPosition="top"
                              pTooltip="{{ 'delete' | translate }}"
                              (click)="onButtonDelete()"
                           >
                              <i class="pi pi-trash logo-default-action"></i>
                           </p-button>
                        </div>
                     }
                  </div>
               </div>
               <div class="flex items-center gap-2 text-xs">
                  <i class="pi pi-info-circle"></i>
                  <span>{{ 'logo_size' | translate }}</span>
               </div>
            </div>
            <div class="flex flex-col gap-3">
               <input
                  id="ep-running-logo-file-input"
                  #inputFile
                  class="hidden"
                  required
                  type="file"
                  accept="image/png, image/jpeg, image/gif"
                  (change)="fileChangeEvent($event)"
               />
               <p-button
                  styleClass="basic-accent-2-button px-8 py-2 hover:py-[8px]"
                  (onClick)="inputFile.click()"
               >
                  <div class="flex gap-2 uppercase items-center">
                     <i class="pi pi-upload"></i>
                     <span class="whitespace-nowrap">{{ 'upload_image' | translate }}</span>
                  </div>
               </p-button>
               <div class="flex items-center gap-2 text-xs">
                  <i class="pi pi-info-circle"></i>
                  <span>{{ 'accepted' | translate }}</span>
               </div>
               <div class="flex items-center gap-2 text-xs">
                  <i class="pi pi-info-circle"></i>
                  <span>Maximum size: 2MB.</span>
               </div>
            </div>
         </div>
         @if (showCropper) {
            <div class="flex flex-col gap-3 p-5 basic-shadow">
               <div class="flex gap-5 justify-center">
                  <p-button
                     class="border border-app-primary-2 p-1 rounded h-fit"
                     styleClass="bg-white border-0 p-0 hover:!bg-white"
                     tooltipStyleClass="basic-app-tooltip-primary-2"
                     [showDelay]="500"
                     tooltipPosition="top"
                     pTooltip="{{ 'zoom_in' | translate }}"
                     (click)="zoom('in')"
                  >
                     <i class="pi pi-search-plus image-icon-action"></i>
                  </p-button>
                  <p-button
                     class="border border-app-primary-2 p-1 rounded h-fit"
                     styleClass="bg-white border-0 p-0 hover:!bg-white"
                     tooltipStyleClass="basic-app-tooltip-primary-2"
                     [showDelay]="500"
                     tooltipPosition="top"
                     pTooltip="{{ 'zoom_out' | translate }}"
                     (click)="zoom('out')"
                  >
                     <i class="pi pi-search-minus image-icon-action"></i>
                  </p-button>
                  <p-button
                     class="border border-app-primary-2 p-1 rounded h-fit"
                     styleClass="bg-white border-0 p-0 hover:!bg-white"
                     tooltipStyleClass="basic-app-tooltip-primary-2"
                     [showDelay]="500"
                     tooltipPosition="top"
                     pTooltip="{{ 'undo' | translate }}"
                     (click)="resetImage()"
                  >
                     <i class="pi pi-replay image-icon-action"></i>
                  </p-button>
                  <p-button
                     class="border border-app-primary-2 p-1 rounded h-fit"
                     styleClass="bg-white border-0 p-0 hover:!bg-white"
                     tooltipStyleClass="basic-app-tooltip-primary-2"
                     [showDelay]="500"
                     tooltipPosition="top"
                     pTooltip="{{ 'remove_image' | translate }}"
                     (click)="removeImage(); cdr.detectChanges()"
                  >
                     <i class="pi pi-trash image-icon-action"></i>
                  </p-button>
               </div>
               @if (showCropper) {
                  <image-cropper
                     [format]="'png'"
                     [aspectRatio]="6 / 4"
                     [alignImage]="'center'"
                     [imageQuality]="100"
                     [output]="'base64'"
                     [transform]="transform"
                     [hideResizeSquares]="true"
                     [maintainAspectRatio]="true"
                     [imageChangedEvent]="imageChangedEvent"
                     (imageLoaded)="imageLoaded()"
                     (imageCropped)="imageCropped($event)"
                  >
                  </image-cropper>
               }
               <div class="flex justify-center">
                  <p-button
                     styleClass="basic-accent-1-button w-[100px] h-[32px] whitespace-nowrap font-semibold "
                     label="{{ 'save' | translate }}"
                     [disabled]="!croppedImageFile?.content"
                     (click)="onButtonSave()"
                  ></p-button>
               </div>
            </div>
         }
      </div>
   }

   @if (showEnlargedLogo) {
      <p-dialog
         [modal]="true"
         [draggable]="false"
         [(visible)]="showEnlargedLogo"
         [header]="'logo' | translate"
         styleClass="app-square-dialog"
      >
         <div class="w-[500px]">
            <img
               class="w-full h-full"
               [src]="getSafeLogo()"
            />
         </div>
      </p-dialog>
   }
</div>
